
(function() {

  const root =
    document.getElementById(
      'europelab-calculator'
    );

  if (!root) return;

  const state = {

    peptide:10,
    water:3,
    dose:500,

    capacity:1,

    unitsPerMl:100,

    scaleMax:100,

    minorStep:2,
    mediumStep:0,
    majorStep:10,
    numberStep:10,

    scaleLabel:'U-100'

  };

  function toNumber(value) {

    return Number(value);

  }

  function formatNumber(
    value,
    decimals
  ) {

    const parsed =
      Number(value);

    if (!Number.isFinite(parsed)) {

      return '0';

    }

    return parsed
      .toFixed(decimals)
      .replace(/\.?0+$/, '');

  }

  function setActive(
    group,
    button
  ) {

    root
      .querySelectorAll(
        '[data-option="' +
        group +
        '"]'
      )
      .forEach(function(item) {

        item.classList.remove(
          'is-active'
        );

      });

    root
      .querySelectorAll(
        '[data-custom-button="' +
        group +
        '"]'
      )
      .forEach(function(item) {

        item.classList.remove(
          'is-active'
        );

      });

    button.classList.add(
      'is-active'
    );

  }

  function createScaleNumber(value) {

    const container =
      root.querySelector(
        '[data-scale-numbers]'
      );

    const label =
      document.createElement(
        'span'
      );

    label.className =
      'elc-scale-number';

    label.textContent =
      String(value);

    label.style.left =
      (
        (value / state.scaleMax)
        * 100
      ) + '%';

    if (value === 0) {

      label.classList.add(
        'is-first'
      );

    }

    if (
      value === state.scaleMax
    ) {

      label.classList.add(
        'is-last'
      );

    }

    container.appendChild(
      label
    );

  }

  function drawScale() {

    const tickContainer =
      root.querySelector(
        '[data-scale-ticks]'
      );

    const numberContainer =
      root.querySelector(
        '[data-scale-numbers]'
      );

    tickContainer.innerHTML = '';

    numberContainer.innerHTML = '';

    for (
      let value = 0;
      value <= state.scaleMax;
      value += state.minorStep
    ) {

      const tick =
        document.createElement(
          'span'
        );

      tick.className =
        'elc-scale-tick';

      tick.style.left =
        (
          (value / state.scaleMax)
          * 100
        ) + '%';

      if (
        value === 0 ||
        value === state.scaleMax
      ) {

        tick.classList.add(
          'is-edge'
        );

      }

      else if (
        value %
        state.majorStep === 0
      ) {

        tick.classList.add(
          'is-major'
        );

      }

      else if (
        state.mediumStep > 0 &&
        value %
        state.mediumStep === 0
      ) {

        tick.classList.add(
          'is-medium'
        );

      }

      tickContainer.appendChild(
        tick
      );

    }

    for (
      let value = 0;
      value <= state.scaleMax;
      value += state.numberStep
    ) {

      createScaleNumber(
        value
      );

    }

    if (
      state.scaleMax %
      state.numberStep !== 0
    ) {

      createScaleNumber(
        state.scaleMax
      );

    }

    const scaleOutput =
      root.querySelector(
        '[data-scale-name-output]'
      );

    if (scaleOutput) {

      scaleOutput.textContent =
        state.scaleLabel;

    }

    const capacityOutput =
      root.querySelector(
        '[data-capacity-label]'
      );

    if (capacityOutput) {

      capacityOutput.textContent =
        formatNumber(
          state.capacity,
          1
        ) +
        ' ml';

    }

  }

  function calculate() {

    const substanceMg =
      toNumber(
        state.peptide
      );

    const solventMl =
      toNumber(
        state.water
      );

    const targetMcg =
      toNumber(
        state.dose
      );

    if (
      !Number.isFinite(
        substanceMg
      ) ||
      !Number.isFinite(
        solventMl
      ) ||
      !Number.isFinite(
        targetMcg
      ) ||
      substanceMg <= 0 ||
      solventMl <= 0 ||
      targetMcg <= 0
    ) {

      root.querySelector('[data-input-error]').hidden = false;
      root.querySelector('.elc-result').hidden = true;
      return;
    }
    root.querySelector('[data-input-error]').hidden = true;
    root.querySelector('.elc-result').hidden = false;
    root.querySelectorAll('[data-option], [data-custom-button], [data-syringe]').forEach(button => button.setAttribute('aria-pressed', String(button.classList.contains('is-active'))));

    const concentration =
      substanceMg /
      solventMl;

    const targetMg =
      targetMcg /
      1000;

    const volumeMl =
      targetMg /
      concentration;

    const syringeUnits =
      volumeMl *
      state.unitsPerMl;

    const rawPercent =
      (
        syringeUnits /
        state.scaleMax
      ) * 100;

    const percent =
      Math.max(
        0,
        Math.min(
          rawPercent,
          100
        )
      );

    root
      .querySelector(
        '[data-result-dose]'
      )
      .textContent =
        formatNumber(
          targetMcg,
          2
        ) +
        ' mcg (' +
        formatNumber(
          targetMg,
          3
        ) +
        ' mg)';

    const volumeText =
      formatNumber(
        volumeMl,
        3
      ) +
      ' ml';

    root
      .querySelector(
        '[data-result-volume]'
      )
      .textContent =
        volumeText;

    root
      .querySelector(
        '[data-result-volume-stat]'
      )
      .textContent =
        volumeText;

    root
      .querySelector(
        '[data-result-concentration]'
      )
      .textContent =
        formatNumber(
          concentration,
          3
        ) +
        ' mg/ml';

    const unitsText =
      formatNumber(
        syringeUnits,
        2
      ) +
      ' jednostek';

    root
      .querySelector(
        '[data-result-units]'
      )
      .textContent =
        unitsText;

    root
      .querySelector(
        '[data-selected-level]'
      )
      .textContent =
        unitsText;

    root
      .querySelector(
        '[data-scale-fill]'
      )
      .style.width =
        percent + '%';

    root
      .querySelector(
        '[data-scale-marker]'
      )
      .style.left =
        percent + '%';

    root
      .querySelector(
        '[data-scale-marker-label]'
      )
      .textContent =
        formatNumber(
          syringeUnits,
          2
        );

    root
      .querySelector(
        '[data-warning]'
      )
      .hidden =
        volumeMl <=
        state.capacity;

  }

  root
    .querySelectorAll(
      '[data-syringe]'
    )
    .forEach(function(button) {

      button.addEventListener(
        'click',
        function() {

          root
            .querySelectorAll(
              '[data-syringe]'
            )
            .forEach(function(item) {

              item.classList.remove(
                'is-active'
              );

            });

          button.classList.add(
            'is-active'
          );

          state.capacity =
            toNumber(
              button.dataset.capacity
            );

          state.unitsPerMl =
            toNumber(
              button.dataset.unitsPerMl
            );

          state.scaleMax =
            toNumber(
              button.dataset.scaleMax
            );

          state.minorStep =
            toNumber(
              button.dataset.minorStep
            );

          state.mediumStep =
            toNumber(
              button.dataset.mediumStep
            );

          state.majorStep =
            toNumber(
              button.dataset.majorStep
            );

          state.numberStep =
            toNumber(
              button.dataset.numberStep
            );

          state.scaleLabel =
            button.dataset.scaleLabel;

          drawScale();

          calculate();

        }
      );

    });

  root
    .querySelectorAll(
      '[data-option]'
    )
    .forEach(function(button) {

      button.addEventListener(
        'click',
        function() {

          const group =
            button.dataset.option;

          const value =
            toNumber(
              button.dataset.value
            );

          setActive(
            group,
            button
          );

          const customBox =
            root.querySelector(
              '[data-custom-box="' +
              group +
              '"]'
            );

          if (customBox) {

            customBox.hidden =
              true;

          }

          state[group] =
            value;

          calculate();

        }
      );

    });

  root
    .querySelectorAll(
      '[data-custom-button]'
    )
    .forEach(function(button) {

      button.addEventListener(
        'click',
        function() {

          const group =
            button.dataset
              .customButton;

          setActive(
            group,
            button
          );

          const box =
            root.querySelector(
              '[data-custom-box="' +
              group +
              '"]'
            );

          if (!box) return;

          box.hidden =
            false;

          const input =
            box.querySelector(
              'input'
            );

          if (input) {

            input.focus();

            const value =
              toNumber(
                input.value
              );

            state[group] = value;
            calculate();

          }

        }
      );

    });

  root
    .querySelectorAll(
      '[data-custom-input]'
    )
    .forEach(function(input) {

      input.addEventListener(
        'input',
        function() {

          const group =
            input.dataset
              .customInput;

          const value =
            toNumber(
              input.value
            );

          state[group] =
            value;

          calculate();

        }
      );

    });

  drawScale();

  calculate();

})();
